module.exports = __webpack_public_path__ + "static/media/stars-2x.edb81dc5.svg";